import React from "react";
import { Filter, FilterSelectedValue } from "../../types";
import { getDefaultSelectedValue } from "./filterDropdownHelpers";
import TicketsFilterDropdown from "./TicketsFilterDropdown";

interface SelectedFilterProps {
  options: Filter[];
  selectedOptions: { [key: string]: FilterSelectedValue };
  onSelectOption: (filterId: string, selectedOption: FilterSelectedValue) => void;
  onDeleteFilter: (filter: { id: string }) => void;
}

export default function SelectedFilter({
  options,
  selectedOptions,
  onSelectOption,
  onDeleteFilter,
}: SelectedFilterProps) {
  return (
    <>
      {options.map((option) => (
        <TicketsFilterDropdown
          key={option.id}
          option={option}
          selectedOptions={
            selectedOptions[option.id] ?? getDefaultSelectedValue(option.pickerType)
          }
          onSelectOption={(selectedOption) =>
            onSelectOption(option.id, selectedOption)
          }
          onDeleteFilter={onDeleteFilter}
        />
      ))}
    </>
  );
}
